import { render, staticRenderFns } from "./SelectTransporte.vue?vue&type=template&id=5f2096fa&"
import script from "./SelectTransporte.vue?vue&type=script&lang=js&"
export * from "./SelectTransporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports